// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2wTma","text":"Select_text__1cXWJ","icon":"Select_icon__2gql0"};